export const REGULATION_PDF_URL =
  process.env.VUE_APP_REGULATION_PDF_URL || "/reglament.pdf";

export const REGISTRATION_LEGAL_ITEMS = [
  {
    id: "regulationAccepted",
    labelKey: "legal.registration.regulation_acknowledgement"
  },
  {
    id: "servicesOrdered",
    labelKey: "legal.registration.voluntary_services_order"
  },
  {
    id: "personalDataConsent",
    labelKey: "legal.registration.personal_data_processing_consent"
  },
  {
    id: "dataIsAccurate",
    labelKey: "legal.registration.order_form_data_accuracy"
  },
  {
    id: "earlyServiceConsent",
    labelKey: "legal.registration.early_service_start_consent"
  }
];

export const CONTRACT_CREATION_LEGAL_ITEMS = [
  {
    id: "contractTariffPaymentOrder",
    labelKey: "legal.contract.tariff_payment_obligation_order"
  }
];
